export interface ClientFrameType {
  nin?: string
  name?: string
  phone?: string
  email?: string
  address?: string
  dateBirth?: string
  compraPara?: {
    enabled: boolean
    ownerName: string
    ownerRut: string
  }
}
import { fechaIsoToDD_MM_YYYY } from '../utils/utils'
export const ClientFrame: React.FC<{ client: ClientFrameType }> = ({ client }) => {
  return (
    <section className="border border-gray-400 p-4 print:border-gray-400 print:p-2 mb-4 print:mb-2 print:break-inside-avoid">
      <h5 className="text-xl print:text-sm font-bold uppercase border-b border-gray-300 pb-2 print:border-b-0 print:pb-0 mb-2 print:mb-1 text-gray-700">
        Datos del Cliente
      </h5>
      <table className="w-full text-base print:text-xs border-separate border-spacing-y-1 print:border-spacing-y-0.5">
        <tbody>
          <tr>
            <td className="w-1/6 text-gray-600 uppercase">Nombre</td>
            <th className="w-2/6 text-left font-bold" colSpan={3}>
              {client.name}
            </th>
            <td className="w-1/6 text-gray-600 uppercase">Rut</td>
            <th className="w-2/6 text-left font-bold">{client.nin}</th>
          </tr>
          <tr>
            <td className="text-gray-600 uppercase">Teléfono</td>
            <th className="text-left font-bold" colSpan={3}>
              {client.phone}
            </th>
            <td className="text-gray-600 uppercase">Email</td>
            <th className="text-left font-bold">{client.email}</th>
          </tr>
          <tr>
            <td className="text-gray-600 uppercase">Dirección</td>
            <th className="text-left font-bold" colSpan={3}>
              {client.address}
            </th>
            {client.dateBirth && (
              <>
                <td className="text-gray-600 uppercase">Fecha Nac.</td>
                <th className="text-left font-bold">{fechaIsoToDD_MM_YYYY(client.dateBirth)}</th>
              </>
            )}
          </tr>
        </tbody>
      </table>
      {client.compraPara?.enabled && (
        <>
          <h5 className="text-xl print:text-sm font-bold uppercase border-b border-gray-300 pb-2 print:border-b-0 print:pb-0 mb-2 print:mb-1 mt-4 text-gray-700">
            COMPRA PARA
          </h5>
          <table className="w-full text-base print:text-xs border-separate border-spacing-y-1 print:border-spacing-y-0.5">
            <tbody>
              <tr>
                <td className="w-1/6 text-gray-600 uppercase">Nombre</td>
                <th className="w-2/6 text-left font-bold" colSpan={3}>
                  {client.compraPara.ownerName}
                </th>
                <td className="w-1/6 text-gray-600 uppercase">Rut</td>
                <th className="w-2/6 text-left font-bold">{client.compraPara.ownerRut}</th>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </section>
  )
}
